import Button from "@components/common/Button";
import Icon from "@components/common/Icon";
import NewFeaturesModal from "./NewFeatures";
import { useEffect, useRef, useState } from "react";
import { onlyForAuthenticated } from "@/app/hooks/onlyFor";
import { useAuth } from "@/app/hooks/useAuth";
import {
	PREFERENCE_NAME_NEW_FEATURES,
	PREFERENCE_NAME_NEW_FEATURES_CLOSED,
} from "./consts";
import Tooltip from "../common/Tooltip/Tooltip";

function HelpCenterLink() {
	const {
		checkPreference,
		checkPreferenceExpired,
		setPreference,
		setPreferenceWithExpiry,
	} = useAuth();
	const buttonRef = useRef<HTMLButtonElement>(null);
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
	const openModal = () => setModalOpen(true);
	const closeModal = (duration: number) => {
		setModalOpen(false);
		if (!checkPreference(PREFERENCE_NAME_NEW_FEATURES_CLOSED)) {
			// first close
			setTooltipOpen(true);
			setPreference(PREFERENCE_NAME_NEW_FEATURES_CLOSED, true);
		}
		setPreferenceWithExpiry(PREFERENCE_NAME_NEW_FEATURES, duration);
	};
	const closeTooltip = () => {
		setTooltipOpen(false);
	};

	useEffect(() => {
		// auto-open
		if (checkPreferenceExpired(PREFERENCE_NAME_NEW_FEATURES)) {
			setModalOpen(true);
		}
	}, [checkPreferenceExpired]);

	return (
		<>
			<Button
				link
				onClick={openModal}
				className="relative"
				ref={buttonRef}
			>
				<Icon name="help" size="lg" />
			</Button>
			<Tooltip
				isOpen={tooltipOpen}
				targetRef={buttonRef}
				onClose={closeTooltip}
			>
				Feature updates can be found in our new Help Center at any time
			</Tooltip>
			<NewFeaturesModal
				isOpen={modalOpen}
				onClose={closeModal}
				triggerRef={buttonRef}
			/>
		</>
	);
}

export default onlyForAuthenticated(HelpCenterLink);
